import { motion, useReducedMotion } from 'framer-motion';
import LabelBackground from '@/components/LabelBackground/LabelBackground';

const SpeciesOfTheWeekLabel = () => {
	const reduceMotion = useReducedMotion();

	return (
		<motion.div
			className="w-fit px-4 lg:mx-auto"
			initial={{
				opacity: 0,
				y: reduceMotion ? 0 : '65%',
			}}
			whileInView={{
				opacity: 1,
				y: 0,
				transition: {
					delay: 0.3,
				},
			}}
		>
			<div className="relative inline-block translate-x-1 translate-y-4 -rotate-2 px-4 pb-3 pt-1 text-accentCompat lg:-rotate-1">
				<LabelBackground className="text-accent" />
				<span className="relative font-brand text-3xl">deze week</span>
			</div>
		</motion.div>
	);
};

export default SpeciesOfTheWeekLabel;
